import '../scss/product.scss';
import { ProductSelector } from "../modules/product-selector.ts";

export default (async () => {
   if (!window.location.pathname.includes('/products')) return;

   (window as any).ProductSelector = new ProductSelector()


   let allValues = document.querySelectorAll('input[type="radio"]');

   if (allValues) {
      [...allValues].forEach((optionValue) => { 

         optionValue.addEventListener("click", () => {
            getSelectedValue();
         })
      })
   }


   let optionClearSelectionButton = document.querySelector('.clear-selection');
   let seletedValueSpots = document.querySelectorAll('.selected-variant-options');

   if (optionClearSelectionButton) {

      optionClearSelectionButton.addEventListener("click", () => {

         for (var v = 0; v < seletedValueSpots.length; v++) {
            seletedValueSpots[v].innerHTML = '';
         }
      })
   }

   function getSelectedValue() {
      for (var x = 0; x < allValues.length; x++) {
         let currentValue = allValues[x];
         if (currentValue.checked) {
            let selectedOptionValueTitle = currentValue.getAttribute('data-option-value');
            let optionId = currentValue.getAttribute('option-id');
            let optionValueSelectedText = 'option-selected-id-' + optionId;


            let optionValueSelectedSpot = document.querySelector('#' + optionValueSelectedText);

            if (selectedOptionValueTitle !== '') {
               optionValueSelectedSpot.innerHTML = selectedOptionValueTitle;
            }
         }
      }
   }


})();